// extracted by mini-css-extract-plugin
module.exports = {"body":"Cart_body__3LhUe","container":"Cart_container__28bj4","emptyText":"Cart_emptyText__3HbZn","cartItem":"Cart_cartItem__1Bl83","totalAmount":"Cart_totalAmount__3yPEz"};